import { ReactNode } from 'react';
import { GridSection } from '../Common/Section';
import { StepProgress } from './StepProgress';
import { StepStatus } from './StepStatus';

interface IStepStatus {
  ok: boolean;
  message: string;
}

interface IStepProgress {
  targetCount: number;
  currentCount: number;
}

interface IProps {
  disabled: boolean;
  disabledReason?: string;
  children: ReactNode;
  stepStatus: IStepStatus;
  title: string;
  subtitle: ReactNode;
  number: number;
  stepProgress?: IStepProgress;
}

export const Step = ({
  disabled,
  disabledReason,
  stepStatus,
  children,
  number,
  title,
  subtitle,
  stepProgress,
}: IProps) => {
  return (
    <div
      data-testid={`firmware-step-${number}`}
      aria-disabled={disabled}
    >
      <GridSection key={number} disabled={disabled}>
        <div className="col-span-1 text-5xl">{number}</div>
        <div className="col-span-2">
          <div>{title}</div>
          <div className="text-xs pt-2 font-light">{subtitle}</div>
          {disabled && disabledReason && (
            <div
              className="text-xs pt-2 font-light text-gray-600"
              role="note"
            >
              {disabledReason}
            </div>
          )}
          {stepProgress && (
            <div className="text-xs pt-4 font-light">
              <StepProgress
                currentCount={stepProgress.currentCount}
                targetCount={stepProgress.targetCount}
              />
            </div>
          )}
        </div>
        <div className="col-span-6 flex flex-row justify-center p-3.5">
          <fieldset disabled={disabled} className="contents">
            {children}
          </fieldset>
        </div>
        <StepStatus {...stepStatus} />
      </GridSection>
    </div>
  );
};
